/** RXNT EHR Gateway void API — voidCode enum + UI labels (value sent as-is). */
export const RXNT_VOID_CODE_OPTIONS = [
  { value: 'NONE', label: 'None' },
  { value: 'PATIENT_UNKNOWN_TO_PRESCRIBER', label: 'Patient unknown to prescriber' },
  { value: 'PATIENT_NEVER_UNDER_PRESCRIBER', label: 'Patient never under prescriber' },
  { value: 'PATIENT_NO_LONGER_UNDER_PRESCRIBER', label: 'Patient no longer under prescriber' },
  { value: 'REFILL_TOO_SOON', label: 'Refill too soon' },
  { value: 'MEDICATION_NEVER_PRESCRIBED', label: 'Medication never prescribed' },
  { value: 'CONTACT_PRESCRIBER', label: 'Contact prescriber' },
  { value: 'REFILL_NOT_APPROPRIATE', label: 'Refill not appropriate' },
  { value: 'ALREADY_PICKED_UP', label: 'Already picked up' },
  { value: 'PARTIALLY_PICKED_UP', label: 'Partially picked up' },
  { value: 'PRESCRIPTION_NOT_PICKED_UP', label: 'Prescription not picked up' },
  { value: 'CHANGE_NOT_APPROPRIATE', label: 'Change not appropriate' },
  { value: 'MUST_BE_SEEN_IN_OFFICE', label: 'Must be seen in office' },
  { value: 'DUPLICATE_PRESCRIPTION', label: 'Duplicate prescription' },
  { value: 'WRONG_PRESCRIBER', label: 'Wrong prescriber' },
];

export const RXNT_VOID_CODE_PLACEHOLDER = { value: '', label: '— Select void reason —' };
